import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

interface CompareRow {
  dim: string;
  left: string;
  right: string;
}

interface ParkingCompareProps {
  data: {
    eyebrow: string;
    title: string;
    subtitle: string;
    leftLabel: string;
    rightLabel: string;
    rows: CompareRow[];
  };
}

export default function ParkingCompare({ data }: ParkingCompareProps) {
  return (
    <section id="compare" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={data.eyebrow} title={data.title} subtitle={data.subtitle} />

        {/* 每个对比维度一张独立小卡片 */}
        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {data.rows.map((row, idx) => (
            <Reveal key={row.dim} delay={idx * 70} className="h-full">
              <div className="h-full rounded-2xl border border-background-200 bg-background-50 overflow-hidden flex flex-col transition-colors hover:border-background-300">
                {/* 维度标题 */}
                <div className="px-4 md:px-5 py-3 flex items-center gap-2 bg-background-100 border-b border-background-200">
                  <span className="w-6 h-6 flex items-center justify-center rounded-md bg-foreground-950 text-background-50 text-xs font-bold font-heading">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <span className="font-heading font-bold text-foreground-950 text-sm md:text-base">{row.dim}</span>
                </div>

                {/* 左右并排对比 */}
                <div className="flex-1 grid grid-cols-2 divide-x divide-background-200">
                  <div className="px-4 md:px-5 py-4 flex flex-col gap-1.5 bg-background-100/50">
                    <span className="inline-flex items-center gap-1.5 text-[11px] font-medium text-foreground-500">
                      <i className="ri-close-circle-line"></i>
                      {data.leftLabel}
                    </span>
                    <span className="text-xs md:text-sm leading-relaxed text-foreground-600">{row.left}</span>
                  </div>
                  <div className="px-4 md:px-5 py-4 flex flex-col gap-1.5 bg-secondary-50">
                    <span className="inline-flex items-center gap-1.5 text-[11px] font-medium text-secondary-700">
                      <i className="ri-checkbox-circle-line"></i>
                      {data.rightLabel}
                    </span>
                    <span className="text-xs md:text-sm leading-relaxed text-foreground-900">{row.right}</span>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}